export const SUPPORTED_LANGUAGE_CODES = ['en'];